<template>
  <div>
    <!-- Top navbar -->
    <nav class="navbar navbar-top navbar-expand-md bg-white shadow border-bottom" id="navbar-main">
      <div class="container-fluid">
        <!-- Brand -->
        <router-link :to="{name: 'mailing'}" class="h4 mb-0 text-uppercase d-none d-lg-inline-block">
          All Mailings
        </router-link>
        <user-data></user-data>
      </div>
    </nav>

    <!-- Page content -->
    <div class="container-fluid mt-0 pt-5 pt-md-8">
      <div class="row mb-5 mb-xl-0">
        <div class="col-md-3">
          <b-form-group label="Site" label-for="session">
            <b-form-select id="session" @input="getMailingList(form), getMeterList()"
              v-model="form.site_id" class="form-control-alternative">
              <option value='null' class="bg-grey text-white" disabled selected>Please select Site</option>
              <option v-for="list in coPropList.data" :key="list.id" v-bind:value='list.id'>{{list.name}}</option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Meter Type" label-for="session">
            <b-form-select id="session" @input="getMailingList(form)"
              v-model="form.service_type_id" class="form-control-alternative" :disabled="form.site_id == null">
              <option value='null' class="bg-grey text-white" disabled selected>Please select Meter</option>
              <option v-for="list in meterList"  :key="list.id" v-bind:value='list.id'>{{list.service_name}}</option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group id="formDate" label="From Date" label-for="formDate">
            <date-picker v-model="form.dateFrom" :config="dateFormat" placeholder="Please select from date"
              class="form-control-alternative" @input="modifyPage(form)" :disabled="form.site_id == null"></date-picker>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group id="toDate" label="To Date" label-for="toDate">
            <date-picker v-model="form.dateTo" :config="dateFormat"  placeholder="Please select to date"
              class="form-control-alternative" @input="modifyPage(form)" :disabled="form.site_id == null || form.dateFrom == ''"></date-picker>
          </b-form-group>
        </div>
      </div>
      <div class="row mt-4" v-if="form.site_id != null && !viewDetailsSession">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow mb-5">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Mailing List</h3>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table class="mt-3" striped hover :items="mailList" :fields="fields">
                <template slot="index" slot-scope="data">
                  {{data.index + 1}}
                </template>
                <template slot="coProp" slot-scope="data">
                  {{data.item.site.name}}
                </template>
                <template slot="meterType" slot-scope="data">
                  {{data.item.service_type.service_name}}
                </template>
                <template slot="mail_scheduled_date" slot-scope="data">
                  {{data.item.mail_scheduled_history.created_at | fmtDate }}
                </template>
                <template slot="doc_type" slot-scope="data">
                  {{data.item.mail_scheduled_history.doc_type }}
                </template>
                <template slot="mail_scheduled_history" slot-scope="data">
                  <span v-if="data.value.mail_scheduled_status == 0">Not Scheduled</span>
                  <span v-if="data.value.mail_scheduled_status == 1">Scheduled (10 PM)</span>
                  <span v-if="data.value.mail_scheduled_status == 2">Completed</span>
                </template>
                <template slot="actions" slot-scope="data">
                  <b-link v-if="data.item.mail_scheduled_history.mail_scheduled_status == 0"
                    class="text-success"  @click='detailView(data.item)'>Schedule</b-link>
                  <b-link v-if="data.item.mail_scheduled_history.mail_scheduled_status == 2 || data.item.mail_scheduled_history.mail_scheduled_status == 1"
                    class="text-info pl-3"  @click='detailView(data.item)'>View Report </b-link>
                  <b-link v-if="data.item.mail_scheduled_history.mail_scheduled_status == 1"
                    class="text-red pl-3" @click='detailView(data.item, true)'> Cancel</b-link>
                </template>
              </b-table>
            </div>
            <div class="card-footer border-0" v-if="mailingList.total_count != 0">
              <b-pagination align="right" @input="pageClick(currentPage)" :total-rows="mailingList.total_count" v-model="currentPage" :per-page="10">
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-4" v-if="form.site_id == null && !viewDetailsSession">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow mb-5">
            <div class="row m-0 px-2 pb-4">
              <div class="col-md-12">
                <h4 class="py-5 my-3 text-center"> Please select co props</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4" v-if="form.site_id != null && viewDetailsSession">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow mb-5">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0 pt-2 float-left">Mailing Report</h3>
                  <b-btn variant="primary" class="float-right" @click="viewDetailsSession = false">All Mails</b-btn>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table class="mt-3" striped hover :items="mailReportDetails.data.data" :fields="fieldsReport">
                <template slot="lotNo" slot-scope="data">
                  {{data.item.lot_owner.lot_no}}
                </template>
                <template slot="name" slot-scope="data">
                  {{data.item.lot_owner.name}}
                </template>
                <template slot="email" slot-scope="data">
                  {{data.item.lot_owner.email}}
                </template>
                <template slot="alternate_email_1" slot-scope="data">
                  {{data.item.lot_owner.alternate_email_1}}
                </template>
                <template slot="alternate_email_2" slot-scope="data">
                  {{data.item.lot_owner.alternate_email_2}}
                </template>
                <template slot="sendOutOn" slot-scope="data">
                  <span v-if="data.item.mail_delivered_status.mail_delievered_on">
                    {{ data.item.mail_delivered_status.mail_delievered_on | fmtDateTime }}
                  </span>
                  <span v-else class="text-muted">—</span>
                </template>
                <template slot="message" slot-scope="data">
                  <span v-if="isSuccess(data.item.mail_delivered_status)" class="text-success">
                    <i class="fas fa-check-circle mr-1"></i> Delivered
                  </span>
                  <span v-else-if="!data.item.mail_delivered_status.mail_delievered_on" class="text-muted">
                    <i class="fas fa-clock mr-1"></i> Scheduled
                  </span>
                  <span v-else class="text-danger">
                    <i class="fas fa-times-circle mr-1"></i> Failed
                    <b-link class="ml-1 text-muted" @click="showError(data.item.mail_delivered_status.message)" title="View error details">
                      <i class="fas fa-info-circle"></i>
                    </b-link>
                  </span>
                </template>
              </b-table>
            </div>
            <div class="card-footer border-0" v-if="mailReportDetails.data.meta.pagination.total != 0">
              <b-pagination align="right" @input="reportPageClick(currentPage)" :total-rows="mailReportDetails.data.meta.pagination.total" v-model="currentPage" :per-page="mailReportDetails.data.meta.pagination.per_page">
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error detail modal -->
    <b-modal ref="errorModal" title="Delivery Error Details" ok-only ok-variant="secondary" ok-title="Close" centered>
      <pre class="text-danger small mb-0" style="white-space: pre-wrap; word-break: break-word;">{{ selectedError }}</pre>
    </b-modal>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  import dayjs from 'dayjs';
  import { toUtcDateString } from '@/utils/dateFormat';
  import datePicker from 'vue-bootstrap-datetimepicker';
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
  import userData from '@/pages/Common/userData';

  export default {
    components: {
      userData,
      datePicker
    },
    data () {
      return {
        currentPage: 1,
        totalPageCount: 1,
        mailList: [],
        viewDetailsSession: false,
        selectedError: '',
        form : {
          site_id: null,
          service_type_id: null,
          dateFrom: '',
          dateTo: '',
          page_no: 1,
        },
        dateFormat: {
          format: 'YYYY-MM-DD',
          useCurrent: false,
        },
        fieldsReport: [
        {
            key: 'id',
            label: 'Ref',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'lotNo',
            label: 'Lot No.',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'name',
            label: 'name',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'email',
            label: 'email',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'alternate_email_1',
            label: 'Alternate email 1',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'alternate_email_2',
            label: 'Alternate email 2',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'sendOutOn',
            label: 'Sent On',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'message',
            label: 'Status',
            sortable: true,
            'class': 'text-center'
          },
        ],
        fields: [
          'index',
          {
            key: 'coProp',
            label: 'Site',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'meterType',
            label: 'Meter Type',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'mail_scheduled_date',
            label: 'Scheduled on',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'doc_type',
            label: 'Document Type',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'mail_scheduled_history',
            label: 'Status',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'actions',
            label: 'Actions',
            sortable: false,
            'class': 'text-center'
          },
        ],
      }
    },
    computed: {
      ...mapGetters('coprops', ['coPropList', 'meterList']),
      ...mapGetters('mailing', ['mailingList', 'mailReportDetails'])
    },
    methods: {
      ...mapActions('coprops', ['ALL_CO_PROP_LIST', 'ALL_METER_LIST']),
      ...mapActions('mailing', ['MAIL_SCHEDULE_LIST', 'MAIL_STATUS', 'MAIL_REPORT']),
      getCoPropList () {
        // Get all site list
        this.ALL_CO_PROP_LIST().then(()=>{
        }).catch(() => {
        });
        // Get all Meter list
        // this.ALL_METER_LIST().then(()=>{
        // }).catch(() => {
        // })
      },
      getMeterList () {
        let meterListDetails = {
          site_id: this.form.site_id
        }
        this.ALL_METER_LIST(meterListDetails).then(()=>{
        }).catch(() => {
        })
      },
      modifyPage (data) {
        data.page_no = 1
        this.form.page_no = 1
        this.getMailingList(data)
      },
      getMailingList(data) {
        if (data.dateTo == '' && data.dateFrom !== '') {
          data.dateTo = dayjs().format('YYYY-MM-DD')
        }
        if (data.dateTo != '') {
          if (data.dateTo < data.dateFrom) {
            this.ERROR_TOAST_MSG('Please select to date greater than from date');
          } else {
            data.dateFrom = toUtcDateString(data.dateFrom)
            data.dateTo   = toUtcDateString(data.dateTo, null, true)
          }
        }
        console.log(data)
        this.MAIL_SCHEDULE_LIST(data).then(()=>{
          this.totalPageCount = Math.ceil(this.mailingList.total_count / 10)
          this.mailList = this.mailingList.data.data
        }).catch(() => {

        });
        // let filterValidate = false

        // if(!data.site_id) {
        //   this.ERROR_TOAST_MSG('Please select coprops');
        // } else {

        //   if(!data.dateFrom && !data.dateTo) {
        //     filterValidate = true
        //   } else {
        //     if (!data.dateFrom) {
        //       this.ERROR_TOAST_MSG('Please select to date');
        //     } else if (!data.dateTo) {
        //       this.ERROR_TOAST_MSG('Please select to date');
        //     } else if(moment(data.dateTo).format('YYYYMMDD') < moment(data.dateFrom).format('YYYYMMDD')) {
        //       this.ERROR_TOAST_MSG('Please select to date greater than from date');
        //     } else {
        //       filterValidate = true
        //     }
        //   }

        //   if(filterValidate) {
        //     this.MAIL_SCHEDULE_LIST(data).then(()=>{
        //       this.totalPageCount = Math.ceil(this.mailingList.total_count / 10)
        //       this.mailList = this.mailingList.data.data
        //     }).catch(() => {

        //     });
        //   }
        // }
      },
      pageClick(data) {
        this.form.page_no = data
        this.getMailingList(this.form);
      },

      reportPageClick(pageNo) {
        this.selectedMailReportDetails.page = pageNo

        this.MAIL_REPORT(this.selectedMailReportDetails).then(() => {
          this.viewDetailsSession = true
        })
      },

      isSuccess(status) {
        if (!status || !status.mail_delievered_on) return false
        return !status.message || /sent successfully/i.test(status.message)
      },
      showError(message) {
        this.selectedError = message
        this.$refs.errorModal.show()
      },
      detailView(data, cancel=false) {
        if(cancel==true) {
          let payload = {
            uuid: data.uuid
          }

          this.MAIL_STATUS(payload).then(()=>{
            this.getMailingList(this.form);
          }).catch(() => {

          });
          return
        }
        if(data.mail_scheduled_history.mail_scheduled_status == 2  || data.mail_scheduled_history.mail_scheduled_status == 1) {
          let mailReportDetails = {
            site_id: data.site.id,
            service_type_id: data.service_type.id,
            created_at: data.created_at,
            uuid: data.uuid,
            page: 1
          }
          
          this.selectedMailReportDetails = mailReportDetails
          this.MAIL_REPORT(mailReportDetails).then(() => {
            this.viewDetailsSession = true
          })
        } else {
          let payload = {
            uuid: data.uuid
          }

          this.MAIL_STATUS(payload).then(()=>{
            this.getMailingList(this.form);
          }).catch(() => {

          });
        }
      }
    },
    created () {
      if (!localStorage.token) {
        localStorage.clear()
        next({
          name: 'adminLogin'
        })
      } else {
        if(localStorage.roleId == 1){
          this.$router.replace({name: "dashboard"});
        }
        this.getCoPropList();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Admin/mailing.vue